$(function () {
    const select = $('.select');
    $(select).on('change', function () {
        if ($(select).val() !== "") {
            $(this).removeClass('select');
        } else {
            $(this).addClass('select');
        }
    });

    const productThumbSwiper = new Swiper('.product_swiper_thumb', {
        spaceBetween: 7,
        slidesPerView: 4.8,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        freeMode: true,
        autoHeight: true,
        
        breakpoints: {
            768: {
                direction: 'vertical',
                spaceBetween: 5,
                slidesPerView: "auto",
            },
        },
    });

    const productMainSwiper = new Swiper('.product_swiper_main', {
        effect: 'fade',

        thumbs: {
            swiper: productThumbSwiper,
        },
        
        // breakpoints: {
        //     768: {

        //     },
        // },
    });

    const productSwiper = new Swiper('.product_swiper', {
        slidesPerView: 1.5,
        spaceBetween: 4.5 + '%',
        
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 4.25 + '%',
            },
        },
    });

    const animationSwiper = new Swiper('.animation_swiper', {
        loop: true,
        slidesPerView: 3,
        speed: 10000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
        },

        breakpoints: {
            768: {
                slidesPerView: 4,
            },
        },
    });

    const voiceSwiper = new Swiper('.voice_swiper', {
        // loop: true,
        slidesPerView: 1.1,
        spaceBetween: 2.4 + '%',
        // autoHeight: true,
        
        autoplay: {
            delay: 3000,
        },
        speed: 500,
        
        breakpoints: {
            768: {
                slidesPerView: 3.425,
            },
        },

        scrollbar: {
            el: '.voice_swiper_scrollbar',
            hide: false,
            draggable: true,
        },
    });

    const swiperSlides = document.getElementsByClassName("swiper-slide");
    const breakPoint = 767; // ブレークポイントを設定
    let spSwiper;
    let swiperBool;

    window.addEventListener(
        "load",
        () => {
            if (breakPoint < window.innerWidth) {
            swiperBool = false;
            } else {
            createSwiper();
            swiperBool = true;
            }
        },
        false
    );

    window.addEventListener(
        "resize",
        () => {
            if (breakPoint < window.innerWidth && swiperBool) {
            spSwiper.destroy(false, true);
            swiperBool = false;
            } else if (breakPoint >= window.innerWidth && !swiperBool) {
            createSwiper();
            swiperBool = true;
            }
        },
        false
    );

    const createSwiper = () => {
        spSwiper = new Swiper(".top_product_swiper", {
            slidesPerView: 1.225,
            spaceBetween: 4.3 + '%',
            
            autoplay: {
                delay: 3000,
            },
            speed: 500,

            scrollbar: {
                el: '.top_product_swiper_scrollbar',
                hide: false,
                draggable: true,
            },
        });
    };

    $('.p_product_details_head').on('click', function() {
        $(this).children('.p_product_details_bars').toggleClass('is-active');
        $(this).next().slideToggle();
    });

    $('.drawerIcon').on('click', function() {
        $(this).toggleClass('active');
        $('.drawerMain').toggleClass('active');
    });

    $('#modal_open').on('click', function() {
        $('.modal').fadeIn(300);
    });

    $('.modal_close').on('click', function() {
        $('.modal').fadeOut(300);
    });

    if($('#js-sidebar').length) {
        $mainContent = $('#js-sidebarMain');
        $mainContentHeight = $mainContent.innerHeight();
        $mainContentTop = $('#js-sidebarMain').offset().top;
        $mainContentBottom = $mainContentTop + $mainContentHeight;
        $sidebar = $('#js-sidebar');
        $sidebarContent = $('.product_sidebar_wrap');
        $sidebarHeight = $('#js-sidebar').innerHeight();
        $header = $('.p_header');
        $headerHeight = $header.innerHeight();

        $winW = $(window).width();

        if($winW > 767) {
            
            $(window).on('scroll', function() {
                let value = $(this).scrollTop();
                if( value > ( $mainContentBottom - $sidebarHeight - $headerHeight )) {
                    $sidebarContent.addClass('active');
                } else {
                    $sidebarContent.removeClass('active');
                };
            });
        }
    };

});
